import { Header } from '../components/Header'
import { Footer } from '../components/Footer'

export const PrivacyPolicy: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20 pb-16">
        <div className="max-w-4xl mx-auto px-4 py-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Polityka Prywatności</h1>

          <div className="prose prose-lg max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Informacje ogólne</h2>
              <p className="text-gray-600 mb-4">
                Niniejsza Polityka Prywatności określa zasady przetwarzania i ochrony danych osobowych użytkowników
                serwisu nazwolab.pl, zgodnie z Rozporządzeniem Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia
                27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych
                i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (RODO).
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Administrator danych</h2>
              <p className="text-gray-600 mb-4">
                Administratorem danych osobowych jest AI SOFTWARE SYSTEMS sp. z o.o.
              </p>
              <p className="text-gray-600 mb-4">
                Kontakt z administratorem: <a href="/contact" className="text-blue-600 hover:text-blue-800">formularz kontaktowy</a>
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Zakres przetwarzanych danych</h2>
              <p className="text-gray-600 mb-4">Przetwarzamy następujące kategorie danych osobowych:</p>
              <ul className="list-disc list-inside text-gray-600 mb-4 space-y-2">
                <li>Dane kontaktowe (imię, nazwisko, adres e-mail)</li>
                <li>Dane techniczne (adres IP, informacje o przeglądarce, system operacyjny)</li>
                <li>Dane dotyczące korzystania z serwisu (historia wyszukiwań, preferencje)</li>
                <li>Dane płatnicze (w przypadku zakupu usług premium)</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Cele i podstawy prawne przetwarzania</h2>
              <div className="space-y-4">
                <div>
                  <h3 className="text-xl font-medium text-gray-800 mb-2">4.1. Świadczenie usług</h3>
                  <p className="text-gray-600">
                    Podstawa prawna: wykonanie umowy (art. 6 ust. 1 lit. b RODO)
                  </p>
                </div>
                <div>
                  <h3 className="text-xl font-medium text-gray-800 mb-2">4.2. Marketing bezpośredni</h3>
                  <p className="text-gray-600">
                    Podstawa prawna: prawnie uzasadniony interes (art. 6 ust. 1 lit. f RODO)
                  </p>
                </div>
                <div>
                  <h3 className="text-xl font-medium text-gray-800 mb-2">4.3. Analityka i ulepszanie usług</h3>
                  <p className="text-gray-600">
                    Podstawa prawna: prawnie uzasadniony interes (art. 6 ust. 1 lit. f RODO)
                  </p>
                </div>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Okres przechowywania danych</h2>
              <ul className="list-disc list-inside text-gray-600 mb-4 space-y-2">
                <li>Dane konta użytkownika: do momentu usunięcia konta</li>
                <li>Dane płatnicze: przez okres wymagany przepisami prawa (5 lat)</li>
                <li>Dane analityczne: maksymalnie 26 miesięcy</li>
                <li>Dane marketingowe: do momentu wycofania zgody lub wniesienia sprzeciwu</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Prawa użytkownika</h2>
              <p className="text-gray-600 mb-4">Przysługują Pani/Panu następujące prawa:</p>
              <ul className="list-disc list-inside text-gray-600 mb-4 space-y-2">
                <li>Prawo dostępu do danych osobowych</li>
                <li>Prawo do sprostowania danych osobowych</li>
                <li>Prawo do usunięcia danych osobowych</li>
                <li>Prawo do ograniczenia przetwarzania</li>
                <li>Prawo do przenoszenia danych</li>
                <li>Prawo do wniesienia sprzeciwu</li>
                <li>Prawo do cofnięcia zgody</li>
                <li>Prawo do wniesienia skargi do UODO</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Pliki cookies</h2>
              <p className="text-gray-600 mb-4">
                Serwis wykorzystuje pliki cookies w celach funkcjonalnych, analitycznych i marketingowych.
                Szczegółowe informacje znajdują się w naszej polityce cookies.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Zmiany polityki prywatności</h2>
              <p className="text-gray-600 mb-4">
                Administrator zastrzega sobie prawo do wprowadzania zmian w niniejszej Polityce Prywatności.
                Aktualna wersja jest zawsze dostępna na stronie internetowej serwisu.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  )
}